import React from 'react';
import './button.css';

const Btn = (props) => {
    return ( 
        <>
        <button>{props.btnText}</button>
        </>
     );
}
 
export default Btn;